export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"}],"link":[{"rel":"icon","type":"image/png","href":"/favicon.png"},{"rel":"preload","as":"image","href":"/img/logo.jpg","fetchpriority":"high"},{"rel":"alternate","href":"https://cfunded.com/","hreflang":"en"},{"rel":"alternate","href":"https://cfunded.com/fa/","hreflang":"fa"},{"rel":"alternate","href":"https://cfunded.com/ar/","hreflang":"ar"},{"rel":"alternate","href":"https://cfunded.com/es/","hreflang":"es"},{"rel":"alternate","href":"https://cfunded.com/hi/","hreflang":"hi"},{"rel":"alternate","href":"https://cfunded.com/zh/","hreflang":"zh"},{"rel":"alternate","href":"https://cfunded.com/","hreflang":"x-default"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon-16x16.png"}],"style":[],"script":[{"src":"https://www.googletagmanager.com/gtag/js?id=G-CESMD2DD4F","async":true},{"innerHTML":"\n              window.dataLayer = window.dataLayer || [];\n              function gtag(){dataLayer.push(arguments);}\n              gtag('js', new Date());\n              gtag('config', 'G-CESMD2DD4F');\n          ","type":"text/javascript"},{"innerHTML":"\n            (function (c, s, q, u, a, r, e) {\n        c.hj=c.hj||function(){(c.hj.q=c.hj.q||[]).push(arguments)};\n        c._hjSettings = { hjid: a };\n        r = s.getElementsByTagName('head')[0];\n        e = s.createElement('script');\n        e.async = true;\n        e.src = q + c._hjSettings.hjid + u;\n        r.appendChild(e);\n    })(window, document, 'https://static.hj.contentsquare.net/c/csq-', '.js', 5342671);\n          ","type":"text/javascript"}],"noscript":[{"children":"JavaScript is required"}],"title":"CFunded"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false